import React from "react"
import { Link } from 'gatsby';

export const Header = ({ siteTitle }) => (
  <header>
    <div id="menuToggle">
      <input type="checkbox" />

      <span></span>
      <span></span>
      <span></span>

      <div id="menu">
        <ul>
          <Link to="/">
            <li>Home</li>
          </Link>
          <li className="sep"></li>
          <Link to="/about">
            <li>About</li>
          </Link>
          <li className="sep"></li>
          <Link to="#">
            <li>Contact</li>
          </Link>
        </ul>
      </div>
    </div>
  </header>
)

Header.defaultProps = {
  siteTitle: ``,
}

